import { UIComponentProps, UIComponentHandler, UIComponentState, UIDataModel, UIComponentImpl } from 'src/com/sixdee/crbtportal/ui/toolkit/uicomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentCSSStyle } from 'src/com/sixdee/crbtportal/ui/toolkit/uicomponentcss';
import { UIComponentView } from 'src/com/sixdee/crbtportal/ui/toolkit/uicomponentview';
import { ListGroupRowCSSStyleImpl } from './listgrouprowcss';
import { ListGroupRowViewImpl } from './listgrouprowview';
import { GroupDto } from 'src/com/sixdee/crbtportal/core/dto/listtones/groupdto';


export interface ListGroupRowComponentProps extends UIComponentProps
{
    groupDto:GroupDto;
    position: number;
    onViewClick(groupDto:GroupDto):void;
    onEditClick(groupDto:GroupDto):void;
    onDeleteClick(groupDto:GroupDto):void;
}

export interface ListGroupRowComponentHandler extends UIComponentHandler
{
    onViewClick():void;
    onEditClick():void;
    onDeleteClick():void;
}

export class  ListGroupRowComponent extends UIComponentImpl<ListGroupRowComponentProps, UIComponentState, UIDataModel> 
implements ListGroupRowComponentHandler
{
    constructor(props: ListGroupRowComponentProps)
    {
        super(props);
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ListGroupRowViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
            return new ListGroupRowCSSStyleImpl(applicationContext);             
    }  

    onViewClick():void
    {
        this.props.onViewClick(this.props.groupDto);
    }

    onEditClick():void
    {
        this.props.onEditClick(this.props.groupDto);

    }

    onDeleteClick():void
    {
        this.props.onDeleteClick(this.props.groupDto);
    }
   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/groups/listgroup/viewmodel/grouprow/listgrouprowcomponent.tsx